<div *ngIf="(compareState | async).compareData.length > 0">
  <div [ngClass]="!(profileState | async).loader['compare']['generate'] ? 'background-loader' : ''">
    <div class="spinner" *ngIf="!(profileState | async).loader['compare']['generate']"></div>

        <div class="card">
          <div class="table-responsive">
            <table class="table compare-results table-fixed">
              <thead>
              <tr>
                <th class="text-center" *ngFor="let profileData of (compareState | async).compareData">
                  <img class="avatar" [src]="profileData.instagram_user.profile_pic_url">
                  <h3 class="mt-4">
                    &#64;{{profileData.instagram_user.username}}
                  </h3>
                  <p class="status-label my-1">
                    <span class="status-green" *ngIf="profileData.audit.status === 2"><span class="dot"></span>Full report</span>
                    <span class="status-orange" *ngIf="profileData.audit.status === 0"><span class="dot"></span>Trial report</span>
                  </p>
                  <p class="sub-text">- {{profileData.audit.added_time * 1000 | date}}</p>
                </th>
                <!--<th>-->
                <!--<button class="btn btn-outline-brand btn-pill ml-3 px-3">+ Add next profile</button>-->
                <!--</th>-->
              </tr>
              </thead>
            </table>
          </div>
        </div>
<!--        <div class="card">-->
<!--          <div class="table-responsive">-->
<!--            <table class="table compare-results">-->
<!--              <tbody>-->
<!--              </tbody>-->
<!--            </table>-->
<!--          </div>-->
<!--        </div>-->
    <div class="card">
      <div class="table-responsive">
        <table class="table compare-results">
          <tbody>
            <tr class="bg-light">
              <td colspan="5"><h4 class="sub-text font-weight-bold">General</h4></td>
            </tr>
            <tr class="text-center">
              <td *ngFor="let profileData of (compareState | async).compareData">
<!--                <img class="avatar" [src]="profileData.instagram_user.profile_pic_url">-->
                <h4 class="my-2" *ngIf="profileData.audit.status === 2"
                    [ngClass]="{
                      'text-red': (compareState | async).compareStat.score.min === profileData.score.score,
                      'text-green': (compareState | async).compareStat.score.max === profileData.score.score}
                    ">
                    {{profileData.score.score}}<small class="text-muted">/100</small>
                  </h4>
                  <a routerLink="/payment/add" *ngIf="profileData.audit.status === 0">
                    <img src="assets/images/icons/lock.png" class="icon-lock"/>
                    <p class="link">PRO DATA</p>
                  </a>
                  <span *ngIf="profileData.audit.status === 1">Pending...</span>
                  <h6 class="sub-text">SocialAuditor Score</h6>
                </td>

              </tr>
            <tr class="text-center">
                <td>
                  <h4 class="text-green my-2">
                    3.43
                  </h4>
                  <h6 class="sub-text">LoveFactor</h6>
                </td>
                <td>
                  <h4 class="text-green my-2">
                    3.43
                  </h4>
                  <h6 class="sub-text">LoveFactor</h6>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
    <div class="card">
      <div class="table-responsive">
        <table class="table compare-results">
          <tbody>
          <tr class="bg-light">
            <td colspan="5"><h4 class="sub-text font-weight-bold">Audience</h4></td>
          </tr>
          <!--        <tr>-->
          <!--          <td colspan="5"><h6 class="sub-text">Total followers</h6></td>-->
          <!--        </tr>-->
          <tr class="text-center">
            <td *ngFor="let profileData of (compareState | async).compareData">
              <h4 class="my-2"
                  [ngClass]="{
                   'text-green': (compareState | async).compareStat.followed_by.max === profileData.instagram_user.followed_by,
                   'text-red': (compareState | async).compareStat.followed_by.min === profileData.instagram_user.followed_by}
               ">
                {{profileData.instagram_user.followed_by | shortcutNumbers}}
              </h4>
              <h6 class="sub-text">Total followers</h6>
            </td>
            <!--        <tr>-->
            <!--          <td colspan="5"><h6 class="sub-text">Quality audience</h6></td>-->
            <!--        </tr>-->
          <tr class="text-center">
            <td *ngFor="let profileData of (compareState | async).compareData">
              <h4 class="my-2" *ngIf="profileData.audit.status === 2"
                  [ngClass]="{
                   'text-red': (compareState | async).compareStat.real_people.min === profileData.follower_stat.followers.real_people.percent,
                   'text-green': (compareState | async).compareStat.real_people.max === profileData.follower_stat.followers.real_people.percent}
               ">
                {{profileData.follower_stat.followers.real_people.percent | number:'1.2'}}%
              </h4>
              <a routerLink="/payment/add" *ngIf="profileData.audit.status === 0">
                <img src="assets/images/icons/lock.png" class="icon-lock"/>
                <p class="link">PRO DATA</p>
              </a>
              <span *ngIf="profileData.audit.status === 1">Pending...</span>
              <h6 class="sub-text">Quality audience</h6>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card">
      <div class="table-responsive">
        <table class="table compare-results">
          <tbody>
          <tr class="bg-light">
            <td colspan="5"><h4 class="sub-text font-weight-bold">Engagement</h4></td>
          </tr>
          <!--        <tr>-->
          <!--          <td colspan="5"><h6 class="sub-text">Engagement rate</h6></td>-->
          <!--        </tr>-->
          <tr class="text-center">
            <td *ngFor="let profileData of (compareState | async).compareData">
              <h4 class="my-2"
                  [hidden]="profileData.audit.status !== 0
                && profileData.audit.bio !== undefined
                && profileData.audit.bio.mention_count !== undefined
                && profileData.audit.bio.mention_count === 0"
                  [ngClass]="{
                   'text-green': (compareState | async).compareStat.follower_engage.max === profileData.follower_engage.engage_count,
                    'text-red': (compareState | async).compareStat.follower_engage.min === profileData.follower_engage.engage_count}
               ">{{profileData.follower_engage.engage_count | number:'1.2'}}%
              </h4>
              <h4 *ngIf="profileData.audit.status !== 0
                && profileData.audit.bio !== undefined
                && profileData.audit.bio.mention_count !== undefined
                && profileData.audit.bio.mention_count === 0">
                No data
                <a data-tooltip="Data is not available due to lack of posts within last 30 days">
                  <img class="icon-info" src="./assets/images/icons/info.png"/>
                </a>
              </h4>
              <h6 class="sub-text">Engagement rate</h6>
            </td>
            <!--        <tr>-->
            <!--          <td colspan="5"><h6 class="sub-text">True engagement rate</h6></td>-->
            <!--        </tr>-->
          <tr class="text-center">
            <td *ngFor="let profileData of (compareState | async).compareData">
              <h4 class="my-2" *ngIf="profileData.audit.status === 2"
                  [hidden]="profileData.audit.status !== 0
                && profileData.audit.bio !== undefined
                && profileData.audit.bio.mention_count !== undefined
                && profileData.audit.bio.mention_count === 0"
                  [ngClass]="{
                   'text-red': (compareState | async).compareStat.true_er.min === profileData.engage_indicator.trueEr,
                   'text-green': (compareState | async).compareStat.true_er.max === profileData.engage_indicator.trueEr}
               ">
                {{profileData.engage_indicator.trueEr | number:'1.2'}}%
              </h4>
              <h4 *ngIf="profileData.audit.status !== 0
                && profileData.audit.bio !== undefined
                && profileData.audit.bio.mention_count !== undefined
                && profileData.audit.bio.mention_count === 0">
                No data
                <a data-tooltip="Data is not available due to lack of posts within last 30 days">
                  <img class="icon-info" src="./assets/images/icons/info.png"/>
                </a>
              </h4>
              <a routerLink="/payment/add" *ngIf="profileData.audit.status === 0">
                <img src="assets/images/icons/lock.png" class="icon-lock"/>
                <p class="link">PRO DATA</p>
              </a>
              <span *ngIf="profileData.audit.status === 1">Pending...</span>
              <h6 class="sub-text">True engagement rate</h6>
            </td>
          </tr>
          <tr>
            <td colspan="5"><h6 class="sub-text">Avg likes per post</h6></td>
          </tr>
          <tr class="text-center">
            <td *ngFor="let profileData of (compareState | async).compareData">
              <h4 class="my-2" *ngIf="profileData.audit.status === 2"
                  [hidden]="profileData.audit.status !== 0
                && profileData.audit.bio !== undefined
                && profileData.audit.bio.mention_count !== undefined
                && profileData.audit.bio.mention_count === 0"
                  [ngClass]="{
                   'text-red': (compareState | async).compareStat.like_avg.min === profileData.media_stat.like.true_media_avg.value,
                   'text-green': (compareState | async).compareStat.like_avg.max === profileData.media_stat.like.true_media_avg.value}
               ">
                {{profileData.media_stat.like.true_media_avg.value | shortcutNumbers}}
              </h4>
              <h4 *ngIf="profileData.audit.status !== 0
                && profileData.audit.bio !== undefined
                && profileData.audit.bio.mention_count !== undefined
                && profileData.audit.bio.mention_count === 0">
                No data
                <a data-tooltip="Data is not available due to lack of posts within last 30 days">
                  <img class="icon-info" src="./assets/images/icons/info.png"/>
                </a>
              </h4>
              <a routerLink="/payment/add" *ngIf="profileData.audit.status === 0">
                <img src="assets/images/icons/lock.png" class="icon-lock"/>
                <p class="link">PRO DATA</p>
              </a>
              <span *ngIf="profileData.audit.status === 1">Pending...</span>
            </td>
          </tr>
          <tr>
            <td colspan="5"><h6 class="sub-text">Avg comments per post</h6></td>
          </tr>
          <tr class="text-center">
            <td *ngFor="let profileData of (compareState | async).compareData">
              <h4 class="my-2" *ngIf="profileData.audit.status === 2"
                  [hidden]="profileData.audit.status !== 0
                && profileData.audit.bio !== undefined
                && profileData.audit.bio.mention_count !== undefined
                && profileData.audit.bio.mention_count === 0"
                  [ngClass]="{
                   'text-red': (compareState | async).compareStat.comment_avg.min === profileData.media_stat.comment.true_media_avg.value,
                   'text-green': (compareState | async).compareStat.comment_avg.max === profileData.media_stat.comment.true_media_avg.value}
               ">
                {{profileData.media_stat.comment.true_media_avg.value | shortcutNumbers}}
              </h4>
              <h4 *ngIf="profileData.audit.status !== 0
                && profileData.audit.bio !== undefined
                && profileData.audit.bio.mention_count !== undefined
                && profileData.audit.bio.mention_count === 0">
                No data
                <a data-tooltip="Data is not available due to lack of posts within last 30 days">
                  <img class="icon-info" src="./assets/images/icons/info.png"/>
                </a>
              </h4>
              <a routerLink="/payment/add" *ngIf="profileData.audit.status === 0">
                <img src="assets/images/icons/lock.png" class="icon-lock"/>
                <p class="link">PRO DATA</p>
              </a>
              <span *ngIf="profileData.audit.status === 1">Pending...</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card">
    <div class="table-responsive">
      <table class="table compare-results">
        <tbody>



        <tr class="bg-light">
          <td colspan="5"><h4 class="sub-text font-weight-bold">Followers demography</h4></td>
        </tr>
        <tr>
          <td colspan="5"><h6 class="sub-text">Top language</h6></td>
        </tr>
        <tr class="text-center">
          <td *ngFor="let profileData of (compareState | async).compareData">
            <h4 class="my-2 text-uppercase" *ngIf="profileData.audit.status === 2">
              {{profileData.audience_stat.lang.buckets[0].key}}
              <br>
              <small>({{((profileData.audience_stat.lang.buckets[0].unique.value / profileData.audience_stat.lang_total.unique.value) * 100) | number:'1.2' }}%)</small>
            </h4>
            <a routerLink="/payment/add" *ngIf="profileData.audit.status === 0">
              <img src="assets/images/icons/lock.png" class="icon-lock"/>
              <p class="link">PRO DATA</p>
            </a>
            <span *ngIf="profileData.audit.status === 1">Pending...</span>
          </td>
        </tr>

        <!--<tr class="bg-light">-->
          <!--<td colspan="5"><h4 class="sub-text font-weight-bold">Location</h4></td>-->
        <!--</tr>-->
        <!--<tr>-->
          <!--<td colspan="5"><h6 class="sub-text">Top country</h6></td>-->
        <!--</tr>-->
        <!--<tr class="text-center">-->
          <!--<td *ngFor="let profileData of (compareState | async).compareData">-->
            <!--<h4 class="my-2 text-uppercase" *ngIf="profileData.audit.status === 2">-->
              <!--{{profileData.audience_location.country_rank[0].key}}-->
              <!--<br>-->
              <!--<small>({{profileData.audience_location.country_rank[0].percent | number:'1.1'}}%)</small>-->
            <!--</h4>-->
            <!--<a routerLink="/payment/add" *ngIf="profileData.audit.status === 0">-->
              <!--<img src="assets/images/icons/lock.png" class="icon-lock"/>-->
              <!--<p class="link">PRO DATA</p>-->
            <!--</a>-->
            <!--<span *ngIf="profileData.audit.status === 1">Pending...</span>-->
          <!--</td>-->
        <!--</tr>-->
        <!--<tr>-->
          <!--<td colspan="5"><h6 class="sub-text">Top city</h6></td>-->
        <!--</tr>-->
        <!--<tr class="text-center">-->
          <!--<td *ngFor="let profileData of (compareState | async).compareData">-->
            <!--<h4 class="my-2 text-capitalize" *ngIf="profileData.audit.status === 2">-->
              <!--{{profileData.audience_location.city_rank[0].key}}-->
              <!--<br>-->
              <!--<small>({{profileData.audience_location.city_rank[0].percent | number:'1.1'}}%)</small>-->
            <!--</h4>-->
            <!--<a routerLink="/payment/add" *ngIf="profileData.audit.status === 0">-->
              <!--<img src="assets/images/icons/lock.png" class="icon-lock"/>-->
              <!--<p class="link">PRO DATA</p>-->
            <!--</a>-->
            <!--<span *ngIf="profileData.audit.status === 1">Pending...</span>-->
          <!--</td>-->
        <!--</tr>-->
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>
